import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { Heart, ArrowRight } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [cat, setCat] = useState("all");

  useEffect(() => {
    api.get(`/blog/posts${cat === "all" ? "" : `?category=${cat}`}`).then((r) => setPosts(r.data));
  }, [cat]);

  const cats = Array.from(new Set(posts.map((p) => p.category)));

  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <section className="py-16 max-w-7xl mx-auto px-6 lg:px-10">
        <div className="uppercase tracking-[0.28em] text-xs text-brand-pink mb-3">The Blog</div>
        <h1 className="font-display text-5xl md:text-6xl max-w-3xl leading-tight">Play by play from <span className="italic text-brand-pink">real hosts</span>.</h1>
        <p className="mt-6 text-neutral-600 max-w-2xl text-lg">Tactical posts on listings, pricing, owners, cleaning, guest experience — no fluff.</p>

        <div className="mt-10 flex flex-wrap gap-3">
          {["all", ...cats].map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              data-testid={`blog-cat-${c}`}
              className={`px-5 py-2.5 rounded-full text-sm font-medium transition ${cat === c ? "bg-brand-pink text-white" : "bg-neutral-100 hover:bg-neutral-200 text-neutral-700"}`}
            >
              {c === "all" ? "All" : c}
            </button>
          ))}
        </div>

        {posts.length === 0 ? (
          <div className="text-center py-24 text-neutral-500">No posts yet. Kristy is writing…</div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-14">
            {posts.map((p) => (
              <Link
                to={`/blog/${p.slug}`}
                key={p.id}
                data-testid={`blog-card-${p.slug}`}
                className="group rounded-3xl overflow-hidden bg-neutral-50 hover:-translate-y-1 transition-transform"
              >
                {p.cover_image && (
                  <div className="aspect-[16/10] overflow-hidden">
                    <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                )}
                <div className="p-6">
                  <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-brand-pink mb-3">
                    <Heart className="w-3 h-3" fill="#E91E63" /> {p.category}
                  </div>
                  <h3 className="font-display text-2xl mb-3 leading-tight">{p.title}</h3>
                  <p className="text-sm text-neutral-600 mb-4 line-clamp-2">{p.excerpt}</p>
                  <div className="text-sm text-brand-pink font-medium inline-flex items-center gap-1">
                    Read post <ArrowRight className="w-3.5 h-3.5" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
